// extracted by mini-css-extract-plugin
module.exports =  {"savingCommandBarItem":"_savingCommandBarItem--32BdF","spin":"_spin--3YCWQ","disabledPointerEvents":"_disabledPointerEvents--7ovhi","progressDots":"_progressDots--3mdhp"};